import {
  TextureLoader,
  RepeatWrapping,
  MeshStandardMaterial,
  DoubleSide,
  PlaneGeometry,
  Mesh,
  BoxGeometry,
  Vector3,
  Box3,
  ClampToEdgeWrapping,
  VideoTexture,
  LinearFilter,
  RGBAFormat,
  MeshBasicMaterial,
  SphereGeometry,
  SpotLightHelper,
  Object3D,
  PointLightHelper,
} from "three";
import { useEffect, useRef, useState } from "react";
import hardWoodDiffuse from "../../assets/hardwood2_diffuse.jpg";
import hardWoodBump from "../../assets/hardwood2_bump.jpg";
import hardWoodRoughnss from "../../assets/hardwood2_roughness.jpg";
import tile1 from "../../assets/tile1.jpg";
import tile2 from "../../assets/tile2.jpg";
import door1 from "../../assets/door1.jpg";
import door2 from "../../assets/door2.jpg";
import door3 from "../../assets/door3.jpg";
import logo from "../../assets/logo.jpg";
import sampleVideo from "../../assets/videos/sample.mp4";
import { loadTexture } from "../../utils/loadingManager";
import { createPointLight, createSpotlight } from "../../utils/threeJsUtils";

function LightsManager({ parent, scene }) {
 // Flag to track if textures have been created
  const isCreatingLights = useRef(false); // Flag to track if textures have been created
  const pointsLights = useRef([]); // Flag to track if textures have been created
  const spotLights = useRef([]); // Flag to track if textures have been created

  const [lightsCreated, setLightsCreated] = useState(false);
  const numLights = 1;
  const lightColor = 0xffee88;
  const lightIntensity = .15;
  const lightDistance = 3;
  const lightDecay = 0;

  useEffect(() => {
    if (!lightsCreated && !isCreatingLights.current) {
      createLights();
    }
  }, []);

  useEffect(() => {
    if (lightsCreated && parent) {
      const bulbs = parent.children.filter((child) =>
        child.name.includes("bulb_01")
      );
      // console.log("bulbs", bulbs);
      // console.log(pointsLights.current)
      bulbs.forEach((bulb, index) => {
        const position = new Vector3();
        bulb.getWorldPosition(position);
        position.y -= .01
        pointsLights.current[index].position.set(position.x, position.y, position.z);
      });
      
      const spotMeshes = parent.children.filter((child) => child.name.includes('spot'))
      // console.log("spotMeshes", spotMeshes);
      spotMeshes.forEach((spotMesh, index) => {
        spotMesh.visible = false
        const position = new Vector3();
        spotMesh.getWorldPosition(position);
        position.y -= 0.01
        spotLights.current[index].position.set(position.x, position.y, position.z);
        const painting = parent.children.find((child) => child.name.includes('painting_frame'))
        const paintingPosition = new Vector3();
        painting.getWorldPosition(paintingPosition)
        const targetObject = new Object3D();
        targetObject.position.copy(paintingPosition)
        targetObject.position.y += 0.2
        scene.add(targetObject);

        spotLights.current[index].target = targetObject
      });


    }

    
  }, [parent]);
 const createLights = () => {
    isCreatingLights.current = true;
    for (let i = 0; i < numLights; i++) {
      const bulbGeometry = new SphereGeometry(0.02, 16, 8);
      const bulbMat = new MeshStandardMaterial({
            emissive: 0xffffee,
            emissiveIntensity: 1,
            color: 0x000000,
          });
      const bulbMesh = new Mesh(bulbGeometry, bulbMat);
      const cashtShodow = false;
      const light = createPointLight(lightColor, lightIntensity, lightDistance, lightDecay, cashtShodow);
      light.add(bulbMesh);
      // const spotLightHelper = new PointLightHelper(light);
      // scene.add(spotLightHelper);
      light.position.set(0, 115, 0);
      console.log("light", light);
      scene.add(light);
      pointsLights.current.push(light);
    }
    const spotLight = createSpotlight(0x000FF, 0.5, 1, 0.5, 0)
    spotLights.current.push(spotLight);
    // const spotHelper = new SpotLightHelper(spotLight)
    // scene.add(spotHelper)
    scene.add(spotLight);
    // isCreatingLights.current = false;
    setLightsCreated(true);
  }




  return null;
}

export default LightsManager;